import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-content-survey',
  templateUrl: './no-content-survey.component.html',
  styleUrls: ['./no-content-survey.component.scss']
})
export class NoContentSurveyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
